// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"874acb13","893":"ec6b19bb"}[chunkId] + ".chunk.js";
};